import { reactMount } from '@/lib/reactMount'
import { useRef } from 'react'
import { Button } from '@/components/Button'
import { ArrowRight } from '@/components/Icons'
export const twoColumnInfoBlock = ({ dataset, umbraco }) => {
  const umbracoRef = useRef(umbraco || JSON.parse(dataset.umbraco))
  umbraco ||= umbracoRef.current

  const backgroundColor = umbraco.BlockBackground ? `#${umbraco.BlockBackground}` : '#ffffff'
  const mediaLeft = umbraco.MediaLeft || false
  const align = umbraco.Alignment || 'center'

  // Button logic matching standaloneCtaBlock pattern
  const primary = umbraco.Button
  const secondary = umbraco.SecondaryButton
  const tertiary = umbraco.TertiaryButton
  const hyperlink = umbraco.ButtonHyperlink

  const buttons = []

  // Primary
  if (primary) {
    buttons.push({
      ...primary,
      variant: 'primary',
      size: 'lg'
    })
  }

  // Secondary preferred over tertiary
  if (secondary) {
    buttons.push({
      ...secondary,
      variant: 'secondary',
      size: 'lg'
    })
  } else if (tertiary) {
    buttons.push({
      ...tertiary,
      variant: 'primary-alt',
      size: 'lg'
    })
  }
  // Hyperlink only if nothing else exists
  else if (hyperlink) {
    buttons.push({
      ...hyperlink,
      variant: 'link',
      size: 'lg'
    })
  }

  const tightSpacing = umbraco.TightSpacing || false

  return (
    <>
      <div
        id={umbraco.AnchorTarget || undefined}
        className={`_block-section _textImageBlock-section relative isolate md:px-4 lg:px-4 ${tightSpacing ? '!pt-2 !pb-3' : 'py-10'} `}
        style={{ backgroundColor }}
      >
        <div className='flex flex-col md:flex-row w-full max-w-[1248px] mx-auto'>
          <div className={`${mediaLeft ? 'order-2' : 'order-1'} md:w-[60%] lg:w-1/2 px-4 flex flex-col ${align === 'center' ? 'justify-center' : ''} ${align === 'bottom' ? 'justify-end' : ''} ${align === 'top' ? 'justify-start' : ''}`}>
            <div className='_rte' dangerouslySetInnerHTML={{ __html: umbraco.Summary }} />
            {umbraco.Button && (
              <div className='mt-7 isolate gap-y-2 gap-x-6 flex md:flex-row flex-wrap'>
                {buttons.map((btn, index) => (
                  <Button
                    key={index}
                    href={btn.Url}
                    target={btn.Target}
                    variant={btn.variant}
                    size={btn.size}
                    componentName={btn.Url?.includes('#apply-dialog') ? 'Two Column Block' : null}
                  >
                    {btn.variant === 'primary-alt'
                      ? (
                        <span className='block relative pr-7'>{btn.Name} <ArrowRight className='absolute -right-0.5 top-1/2 -mt-[11px]' /></span>
                        )
                      : (
                          btn.Name || 'Learn more'
                        )}
                  </Button>
                ))}
              </div>
            )}
          </div>
          <div className={`${mediaLeft ? 'order-1 mb-8 md:mb-0' : 'order-2 mt-8 md:mt-0'} md:w-[40%] lg:w-1/2 flex px-4 justify-end`}>
            <div className={`w-full justify-center flex ${mediaLeft ? 'md:justify-start' : 'md:justify-end'} ${align === 'center' ? 'items-center' : ''} ${align === 'bottom' ? 'items-end' : ''} ${align === 'top' ? 'items-start' : ''}`}>
              <div className={`relative w-full  max-w-[448px] flex justify-center items-center ${tightSpacing ? 'md:h-[220px]' : 'md:max-h-[448px] md:aspect-[3/2.25]'}`}>
                <img src={umbraco.Media.Url} className={`max-w-full max-h-full w-auto h-auto ${tightSpacing ? 'md:max-h-[208px]' : ''}`} alt={umbraco.Media.AltText} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

reactMount('twoColumnInfoBlock', twoColumnInfoBlock)
